/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { InputType } from '../../nos-business-sign-up';

export interface IBusinessSignUpInputProps {
    id?: string;
    type: InputType;
    value: string;
    pattern?: string;
    className: string;
    options?: any[];
    onChangeInput: (event: any, value: string, type: string) => void;
    selectedValue: any;
    isSubmittedPressed: boolean;
}

const SignUpInputPhonePicker: React.FC<IBusinessSignUpInputProps> = ({
    id,
    type,
    value,
    pattern,
    className,
    onChangeInput,
    options,
    selectedValue = '+',
    isSubmittedPressed
}) => {
    const handlePhoneCodeChange = (event: any, value: string, select: string) => {
        const re = /^[\+]+[0-9\b]+$/;
        const replus = /^[\+]+$/;
        if (re.test(event.target.value) || replus.test(event.target.value)) {
            onChangeInput(event, value, select);
        }
    };

    return (
        <React.Fragment>
            <div className='ms-form__group-horizontal'>
                <div className='col-4 col-md-3'>
                    <input
                        id={id}
                        type={'text'}
                        placeholder={'+49'}
                        value={selectedValue ?? '+'}
                        className={`${className}-input ms-form__input ${selectedValue === '+' && isSubmittedPressed && 'necessary'}`}
                        pattern={pattern !== '' ? pattern : undefined}
                        onChange={(event: any) => handlePhoneCodeChange(event, value, 'select')}
                    />
                </div>
                <div className='col-8 col-md-9'>
                    <input
                        id={id}
                        type={'number'}
                        placeholder={'2233445566'}
                        value={value}
                        className={`${className}-input ${className}-${id} ms-form__input ${(value === '+' || value === '') &&
                            isSubmittedPressed &&
                            'necessary'}`}
                        pattern={pattern !== '' ? pattern : undefined}
                        onChange={(event: any) => onChangeInput(event, value, 'input')}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

export default SignUpInputPhonePicker;
